import { CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { Booth, Exhibitor } from '../../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../../reduxToolkit/typedRedux';
import { getAllExhibitors } from '../../../../../../../services/services';
import ExhibitorInformationList from '../../../../../../account/Booth/BoothExhibitorInformation/ExhibitorInformationList';
import { TabContentWrapper } from './TabContentWrapper';

const BoothInformationTab = ({ booth }: { booth: Booth }) => {
  const event = useSelector((state) => state.common.event);

  const [exInformation, setExInformation] = useState<Exhibitor[]>([]);
  const [loading, setLoading] = useState(false);

  async function fetch() {
    if (event) {
      setLoading(true);
      const exhibitors = await getAllExhibitors(event._id);
      try {
        setExInformation(
          exhibitors.map((entry: any) => {
            return { ...entry, datetime_created: new Date(entry.datetime_created).toLocaleString() };
          })
        );
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    }
  }

  useEffect(() => {
    if (event) fetch();
  }, [event]);

  return (
    <TabContentWrapper>
      <div className="w-full flex flex-col ">
        {loading ? (
          <div className="w-full h-full grid place-items-center">
            <CircularProgress />
          </div>
        ) : (
          <ExhibitorInformationList exInformation={exInformation} />
        )}
      </div>
    </TabContentWrapper>
  );
};
export default BoothInformationTab;
